import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GroupIconComponent} from './group-icon/group-icon.component';
import {CaretDownIconComponent} from './caret-down-icon/caret-down-icon.component';
import {GridIconComponent} from './grid-icon/grid-icon.component';
import {FloorIconComponent} from './floor-icon/floor-icon.component';
import {CrossIconComponent} from './cross-icon/cross-icon.component';
import {PlusIconComponent} from './plus-icon/plus-icon.component';
import {SaveIconComponent} from './save-icon/save-icon.component';
import {BackIconComponent} from './back-icon/back-icon.component';
import {MapIconComponent} from './map-icon/map-icon.component';
import {DeviceMarkerIconComponent} from './device-marker-icon/device-marker-icon.component';
import {PinIconComponent} from './pin-icon/pin-icon.component';
import {CogIconComponent} from './cog-icon/cog-icon.component';
import {CaretRightSharpIconComponent} from './caret-right-sharp-icon/caret-right-sharp-icon.component';
import {CaretLeftIconComponent} from './caret-left-icon/caret-left-icon.component';
import {CaretRightIconComponent} from './caret-right-icon/caret-right-icon.component';
import {ShowIconComponent} from './show-icon/show-icon.component';
import {HideIconComponent} from './hide-icon/hide-icon.component';
import {WarningIconComponent} from './warning-icon/warning-icon.component';
import {EnterIconComponent} from './enter-icon/enter-icon.component';
import {LoadingIconComponent} from './loading-icon/loading-icon.component';
import {CheckIconComponent} from './check-icon/check-icon.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    GroupIconComponent,
    CaretDownIconComponent,
    CaretLeftIconComponent,
    CaretRightIconComponent,
    CaretRightSharpIconComponent,
    GridIconComponent,
    FloorIconComponent,
    CrossIconComponent,
    PlusIconComponent,
    SaveIconComponent,
    BackIconComponent,
    MapIconComponent,
    PinIconComponent,
    DeviceMarkerIconComponent,
    CogIconComponent,
    ShowIconComponent,
    HideIconComponent,
    WarningIconComponent,
    EnterIconComponent,
    LoadingIconComponent,
    CheckIconComponent
  ],
  declarations: [
    GroupIconComponent,
    CaretDownIconComponent,
    CaretLeftIconComponent,
    CaretRightIconComponent,
    CaretRightSharpIconComponent,
    GridIconComponent,
    FloorIconComponent,
    CrossIconComponent,
    PlusIconComponent,
    SaveIconComponent,
    BackIconComponent,
    MapIconComponent,
    PinIconComponent,
    DeviceMarkerIconComponent,
    CogIconComponent,
    ShowIconComponent,
    HideIconComponent,
    WarningIconComponent,
    EnterIconComponent,
    LoadingIconComponent,
    CheckIconComponent
  ]
})

export class IconModule {
}
